import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { FormattedDate, FormattedMessage } from '../../util/reactIntl';

import css from './PromotedBadge.module.css';

/**
 * PromotedBadge
 *
 * Pill on contacts a member chose to share with the Org through the Gig Boost
 * Dual Opt-In wizard:
 *
 *   PROMOTED · via Marko N · Backstage Live Room · 24 Aug 2026
 *
 * Deliberately distinct from both owned rows (no badge) and RentedBadge:
 * a promoted contact stays with the Org after the assignment ends, and
 * keeping that visible in the table — not only in an audit log — is what
 * makes the "we don't take your audience" claim checkable.
 */
const PromotedBadge = props => {
  const { className, creatorName, sourceTitle, promotedAt } = props;
  const at = promotedAt ? new Date(promotedAt) : null;
  const hasDate = at && !Number.isNaN(at.getTime());

  return (
    <span className={classNames(css.root, className)}>
      <span className={css.label}>
        <FormattedMessage id="PromotedBadge.label" />
      </span>
      {creatorName ? (
        <>
          <span className={css.divider} aria-hidden>
            ·
          </span>
          <span className={css.detail}>
            <FormattedMessage id="PromotedBadge.viaCreator" values={{ name: creatorName }} />
          </span>
        </>
      ) : null}
      {sourceTitle ? (
        <>
          <span className={css.divider} aria-hidden>
            ·
          </span>
          <span className={css.detail}>{sourceTitle}</span>
        </>
      ) : null}
      {hasDate ? (
        <>
          <span className={css.divider} aria-hidden>
            ·
          </span>
          <span className={css.detail}>
            <FormattedDate value={at} year="numeric" month="short" day="numeric" />
          </span>
        </>
      ) : null}
    </span>
  );
};

PromotedBadge.defaultProps = {
  className: null,
  creatorName: null,
  sourceTitle: null,
  promotedAt: null,
};

PromotedBadge.propTypes = {
  className: string,
  creatorName: string,
  sourceTitle: string,
  promotedAt: string,
};

export default PromotedBadge;
